import { connect } from 'react-redux';
import { selectAdminUserRole, selectCompanyDetails } from '../../selectors/auth';

const mapStateToProps = (state) => ({
  company: selectCompanyDetails(state),
  isAdmin: selectAdminUserRole(state),
});

export default connect(mapStateToProps, null);
